/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberQuestionnaireHistoryModel } from '../../models/member-questionnaire-history-model';

export interface ApiConsumerQuestionnaireHistoryGet$Params {
  questionnaireId?: string;
  includeInProgress?: boolean;
}

export function apiConsumerQuestionnaireHistoryGet(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireHistoryGet$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<MemberQuestionnaireHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireHistoryGet.PATH, 'get');
  if (params) {
    rb.query('questionnaireId', params.questionnaireId, {});
    rb.query('includeInProgress', params.includeInProgress, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<MemberQuestionnaireHistoryModel>;
    })
  );
}

apiConsumerQuestionnaireHistoryGet.PATH = '/api/consumer/questionnaire/history';
